import { DRAGGABLE_FORM_SIZES } from '@constants'

export const getCenteredPositionWindow = (
  customSize: { height: number; width: number } = {
    height: DRAGGABLE_FORM_SIZES.OPENED_HEIGHT,
    width: DRAGGABLE_FORM_SIZES.OPENED_WIDTH,
  }
) => ({
  x: (window.innerWidth - customSize.width) / 2 + window.scrollX,
  y: (window.innerHeight - customSize.height) / 2 + window.scrollY,
})
